import TextField, { TextFieldProps } from '@mui/material/TextField'
import type { ReactNode } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

export interface RHFSelectProps {
  name: string
  options?: SelectOption[]
  children?: ReactNode
}

interface SelectOption {
  label: ReactNode
  value: any
}

export function RHFSelect({ name, children, options, ...other }: RHFSelectProps & TextFieldProps) {
  const { control } = useFormContext()

  if (options) {
    children = options.map(option => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...field }, fieldState: { error } }) => (
        <TextField
          {...field}
          inputRef={ref}
          select
          fullWidth
          SelectProps={{ native: true }}
          error={!!error}
          helperText={error?.message}
          size={other.size ?? 'small'}
          {...other}
        >
          {children}
        </TextField>
      )}
    />
  )
}
